export interface Producto {
  id: string;
  fecha: string;
  categoria: string;
  producto: string;
  unidad: string;
  proveedor: string;
  entradas: number;
  fechaEntrada: string;
  fechaCaducidad: string;
  salidas: number;
  mermas: number;
  stockFinal: number;
  stockMinimo: number;
  stockMaximo: number;
  puntoReorden: number;
  costoUnitario?: number;
  tipoProducto?: 'basico' | 'especialidad' | 'premium';
}

export interface DashboardStats {
  totalProductos: number;
  productosStockBajo: number;
  productosVencidos: number;
  productosProximosAVencer: number;
  valorInventario: number;
}

export interface Categoria {
  nombre: string;
  productos: Producto[];
}

export enum AlertasTipo {
  STOCK_BAJO = 'stock_bajo',
  VENCIDO = 'vencido',
  PROXIMO_VENCER = 'proximo_vencer',
  REORDEN = 'reorden'
}

export interface Alerta {
  _id?: string;
  productoId: string;
  productoNombre: string;
  tipo: AlertasTipo;
  mensaje: string;
  prioridad: 'alta' | 'media' | 'baja';
  stockActual?: number;
  stockMinimo?: number;
  fechaCaducidad?: string;
  fechaCreacion: string;
  activa: boolean;
  fechaResolucion?: string;
  resueltoPor?: string;
}

export interface ConsumoPersonal {
  id: string;
  empleadoId: string;
  empleadoNombre: string;
  fecha: string;
  hora: string;
  bebida: string;
  tipoBebida: 'basico' | 'especialidad' | 'premium';
  cantidad: number;
  costo: number;
  autorizado: boolean;
  notas?: string;
}

export interface ConfiguracionConsumo {
  limiteDiario: number;
  bebidasPermitidas: string[];
  restriccionPorTipo: boolean;
  tiposPermitidos: ('basico' | 'especialidad' | 'premium')[];
}

export interface RegistroMovimiento {
  id: string;
  fecha: string;
  tipo: 'entrada' | 'salida' | 'consumo_personal' | 'merma' | 'ajuste';
  productoId: string;
  productoNombre: string;
  cantidad: number;
  unidad: string;
  motivo?: string;
  empleadoResponsable?: string;
  costo?: number;
  notas?: string;
}

export interface Supplier {
  _id: string;
  nombre: string;
  contacto?: string;
  telefono?: string;
  email?: string;
  direccion?: string;
  notas?: string;
  activo: boolean;
  fechaCreacion: string;
  ultimaActualizacion: string;
}

export interface RecipeIngredient {
  inventoryProductId: string;
  inventoryProductName: string;
  quantity: number;
  unit: string;
}

export interface Recipe {
  _id?: string;
  menuItemName: string;
  category: string;
  ingredients: RecipeIngredient[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface MovimientoInventario {
  _id?: string;
  fecha: string;
  tipo: 'venta' | 'entrada' | 'salida' | 'merma' | 'ajuste' | 'consumo_personal';
  productoId: string;
  productoNombre: string;
  cantidad: number;
  unidad: string;
  stockAnterior: number;
  stockNuevo: number;
  motivo: string;
  referencia?: string;
  usuario?: string;
  createdAt: string;
}